<template>
  <div>
    <loading v-show="showLoader" />

    <div class="ib-main-section">
      <div class="container">
        <router-link class="ib-back-btn" :to="{ name: 'Home' }">Back</router-link>
        <div class="row">
          <div class="col-md-6 pl-0">
            <div class="d2c-class-container" style="padding-top: 77px;">
              <!-- Nav tabs -->
              <h2 class="listing-page-title">Notifications</h2>
            </div>
          </div>
          <div class="col-md-6 in-page-infographic">
            <img class="img-fluid" alt="icon" :src="require('@/assets/images/claim-policy-right-img.svg')" />
          </div>
        </div>
      </div>

      <div class="container multistep-box" style="margin: 50px auto 20px; text-align: center;">
        <div class="row mb-4">
          <div class="col-md-12">
            <div class="py-2">
              <nav>
                <div class="nav nav-tabs ib-acq-navtab" id="nav-tab" role="tablist">
                  <a class="nav-item nav-link acq-nav-btn active" id="product-tab" data-toggle="pill" href="#product" role="tab" aria-controls="product" aria-selected="true"><i class="fa fa-bell mr-1"></i>Notifications</a>
                  <a class="nav-item nav-link acq-nav-btn" id="contact-tab" data-toggle="pill" href="#contact" role="tab" aria-controls="contact" aria-selected="false"><i class="fa fa-bullhorn mr-1"></i>Announcements</a>
                </div>
              </nav>
            </div>
          </div>
          <h4 class="ib-dotted-hr" style="width:100% !important;"></h4>
          <div class="col-lg-12">
            <div class="tab-content" id="v-pills-tabContent">
              <div class="tab-pane tab-pane-quotation fade show active" id="product" role="tabpanel" aria-labelledby="product-tab">
                <div class="container">
                  <div v-for="notification in notifications"  @click="CheckNotification(notification.id)">
                    <router-link class="promotion-link" :class="(notification.is_read === 0) ? 'notification-unread' : ''" v-if="notification.claim_id != null" :to="{ name: 'ClaimsView', params: { id: notification.claim_id }}" :key="notification.id">
                      <div class="first-div">
                        <img :src="require('@/assets/images/buy.svg')" alt />
                      </div>
                      <div class="second-div">
                        <div class="title">
                        {{ notification.notification_title }}
                      </div>
                      <div>
                        <p class="text">{{ notification.notification_msg }}</p>
                      </div>
                      </div>
                      <span class="text-right float-right time-ago">{{ DateDiff(notification.created_at) }}</span>
                    </router-link>
                    <router-link class="promotion-link" :class="(notification.is_read === 0) ? 'notification-unread' : ''" v-if="notification.customer_quotation_id != null" :to="{ name: 'PolicyView', params: { source: 'self', id: notification.customer_quotation_id }}" :key="notification.id">
                      <div class="first-div">
                        <img :src="require('@/assets/images/buy.svg')" alt />
                      </div>
                      <div class="second-div">
                        <div class="title">
                          {{ notification.notification_title }}
                        </div>
                        <div>
                          <p class="text">{{ notification.notification_msg }}</p>
                        </div>
                      </div>
                      <span class="text-right float-right time-ago">{{ DateDiff(notification.created_at) }}</span>
                    </router-link>
                    <router-link class="promotion-link" :class="(notification.is_read === 0) ? 'notification-unread' : ''" v-if="notification.complain_id != null" :to="{ name: 'ComplaintView', params: { id: notification.complain_id }}" :key="notification.id">
                      <div class="first-div">
                        <img :src="require('@/assets/images/buy.svg')" alt />
                      </div>
                      <div class="second-div">
                        <div class="title">
                          {{ notification.notification_title }}
                        </div>
                        <div>
                          <p class="text">{{ notification.notification_msg }}</p>
                        </div>
                      </div>
                      <span class="text-right float-right time-ago">{{ DateDiff(notification.created_at) }}</span>
                    </router-link>
                  </div>
                  <a href="#" style="color: #2FBCDF" @click="ReadMore()" v-if="notifications.length > 0">Read More</a>
                  <h2 v-else style="color: rgba(0, 0, 0, 0.3) !important ">No Notification Found!</h2>
                </div>
              </div>
              <div class="tab-pane tab-pane-quotation fade" id="contact" role="tabpanel" aria-labelledby="contact-tab">
                <div class="container">
                  <a class="promotion-link" v-for="(promotion, index) in allPromotions">
                    <div class="first-div">
                      <img :src="require('@/assets/images/buy.svg')" alt />
                    </div>
                    <div class="second-div">
                      <div class="title">{{promotion.title}} </div>
                      <div><p class="text">{{promotion.description}}</p></div>
                    </div>
                    <span class="text-right float-right time-ago">{{DateDiff(promotion.created_at)}}</span>
                  </a>
                  <h2 style="color: rgba(0, 0, 0, 0.3) !important" v-if="allPromotions.length == 0">No Announcement Available!</h2>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import loading from '@/components/Loading/Loading'
  import moment from "moment";

  export default {
    name: 'Notifications',
    components: {
      loading
    },
    data() {
      return {
        showLoader: false,
        notifications: {},
        notificationsIcon: false,
        notificationCount: 0,
        notificationStepCount: 5,
        complainsList: {},
        complains: {},
        complaints: {},
        allPromotions: []
      };
    },
    created: function () {
      const self = this;
      self.getData();
    },
    computed: {
      date() {
        return moment().format('YYYY-MM-DD');
      }
    },
    methods: {
      ReadMore(){
        let self = this;
        self.notificationStepCount = self.notificationStepCount + 5;
        this.getData();
      },
      async getData() {
        const self = this;
        const promises = [];

        self.showLoader = true;
        promises.push(await axios.get('customer/notifications/user_notifications?current_page=1&paginate=yes&order_sort=desc&per_page=' + self.notificationStepCount).then(function (resp) {
          if (resp.data.code == 200) {
            self.notifications = {};
            self.notifications = resp.data.data.notifications;
            self.notificationCount = self.notifications.filter(x => x.is_read === 0 );
            self.$root.$emit('updateNotificationCount', self.notificationCount.length);
          } else {
            self.showLoader = false;
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        }));

        promises.push(await axios.post('promotions').then(function (resp) {
          if(resp.data.code == 200) {
            self.allPromotions = resp.data.data;
          } else {
            self.showLoader = false;
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          error.response.data.errors.forEach(element => {
            $toast.error(element.message, { position: 'top-right' });
          });
          return false;
        }));

        Promise.all(promises).then(() => {
          self.showLoader = false;
        });
      },
      async CheckNotification(id) {
        const self = this;
        self.showLoader = true;
        await axios.post('customer/notifications/update_status',{ 'notification_id' : id }).then(function (resp) {
          self.showLoader = false;
          if (resp.data.code == 200) {
            self.GetNotifications();
          } else {
            $toast.error(resp.data.message, { position: 'top-right' });
            return false;
          }
        }).catch(function (error) {
          self.showLoader = false;
          if(error.data.errors != undefined) {
            error.data.errors.forEach(element => {
              $toast.error(element.message, { position: 'top-right' });
            });
          } else {
            $toast.error(error.data.message, { position: 'top-right' });
          }
        });
      },
      DateDiff(serverDate) {
        const myDate = new Date();
        var a = moment(myDate);
        var b = moment(serverDate);
        var response = '';

        var diff = a.diff(b, 'months');
        response = diff + ' Months Ago';

        if(diff === 0) {
          diff = a.diff(b, 'days');
          response = diff + ' Days Ago';
        }

        if(diff === 0) {
          diff = a.diff(b, 'hours');
          response = diff + ' Hours Ago';
        }

        if (diff === 0) {
          diff = a.diff(b, 'minutes');
          response = diff + ' Minutes Ago';
        }

        return response;
      }
    }
  };
</script>

<style scoped>
  .data-row p {
    color :#5b6770;
  }
  table > tbody > tr, .data-row {
    margin: 10px 0;
    padding: 20px 30.7px 20px 15px;
    border-radius: 10px;
    border: solid 1px #dedada;
    background-color: #ffffff;
  }
  .data-row .action-area {
    text-align: right;
  }
  .data-row .action-area i {
    width: 7.9px;
    height: 14.6px;
    color: #5b6770;
  }
  .data-row .claim-row-sub-heading {
    color: #a9adaf;
  }
  .data-row .claim-row-sub-desc {
    color: #5b6770;
  }
  .data-row .status-danger {
    background-color: rgba(30, 203, 16, 0.09);
    font-size: 12px;
    font-stretch: normal;
    font-style: normal;
    color: #1ecb10;
    letter-spacing: normal;
  }
  .data-row .status {
    margin: 10px 61.3px 10px 52px;
    padding: 6px 24px;
    border-radius: 6px;
    font-family: "Futura PT";
  }
  .data-row .claim-row-data {
    font-family: "Futura PT";
    font-size: 17px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 8px;
    letter-spacing: normal;
    text-align: left;
  }
  .data-row .claim-row-heading {
    font-family: "Futura PT";
    font-size: 22px;
    font-weight: 500;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.32;
    letter-spacing: normal;
    text-align: left;
    color: #5b6770;
  }
  table > tbody > tr > th > img,.data-img img {
    width: 79px;
    height: 66px;
    border-radius: 11px;
  }
  .position-relative .small-icon {
    border-radius: 50%;
    position: absolute;
    width: 25px;
    height: 25px;
    top: -20px;
    right: 14px;
  }
  table.claim-listing {
    width: 100%;
    margin: 0 auto;
    font-family: Arial, sans-serif;
    border-collapse: separate;
    border-spacing: 0 10px;
  }
  table.claim-listing td {
    height: 100px !important;
    vertical-align: middle;
    text-align: center;
    position: relative;
  }
  @media (max-width:668px) {
    table.claim-listing td:not(:first-child) {
      height: 60px !important;
    }
    table.claim-listing tbody td:first-child{
      height: auto !important;
    }
  }
  table.claim-listing td:last-child:after {
    content: none;
  }
  table.claim-listing tbody td {
    border-top: 1px solid #eee;
    border-bottom: 1px solid #eee;
    cursor: pointer;
  }
  @media (min-width:669px) {
    table.claim-listing tbody td:first-child {
      border-left: 1px solid #eee;
      border-top-left-radius: 10px;
      border-bottom-left-radius: 10px;
    }
    table.claim-listing tbody td:last-child {
      border-right: 1px solid #eee;
      border-top-right-radius: 10px;
      border-bottom-right-radius: 10px;
    }
    table.claim-listing tbody tr {
      box-shadow: 0 3px 26px 0 rgba(0, 0, 0, 0.08);
    }
  }
  .jbl-table-heading span {
    font-size: 19px;
    font-size: 10px;
    color: #5b6770;
    font-weight: normal !important;
  }
  table.claim-listing .fa-chevron-right {
    padding-right: 2rem;
    color: #5b6770;
  }
  @media (min-width:668px) and (max-width:992px) {
    table.claim-listing .fa-chevron-right {
      padding-right: 1rem;
      color: #5b6770;
    }
  }
  .d2c-main-classes .d2c-class-btn::after {
    content: '';
    width: 0;
    height: 35px;
    border: solid 1px #049ab3;
    position: relative;
    right: -16px;
  }
  .d2c-main-classes.d2c-class-tabs button.d2c-class-btn::after {
    content: '';
    border: none !important;
  }
  .d2c-main-classes button:last-child.d2c-class-btn::after {
    content: '';
    border: none !important;
  }
  .nex-Page-Link .fa-chevron-right {
    color: #aeccd6 !important;
    font-weight: normal !important;
  }
  a.promotion-link {
    font-size: 16px !important;
    font-weight: normal !important;
    line-height: 1.5 !important;
    text-align: left !important;
    color: #c1c1c1 !important;
    text-transform: none !important;
    /* padding: 9px 27px 16px 10px; */
    padding: 13px;
    border-radius: 10px;
    border: solid 1px rgba(55, 141, 171, 0.25);
    background-color: #ffffff;
    display: block;
    margin-bottom: 2rem;
    display: flex;
    align-items: center;
    position: relative;
  }
  @media (max-width:768px) {
     a.promotion-link {
      display: flex;
      flex-direction: column !important;
    }
  }
  a.promotion-link div.title {
    font-family: "Avenir Heavy";
    /* font-size: 20px; */
    font-size: 18px;
    /* font-weight: 900; */
    text-align: left;
    color: #3d9cbd;
    text-transform: capitalize;
  }
  .text {
    font-family: "Avenir Book";
    font-size: 15px;
    font-weight: normal;
    text-align: left;
    color: #c6c5c5;
    /* text-transform: capitalize; */
  }
  .text::first-letter{
    text-transform: capitalize;
  }
  .panel-title > a,
  .panel-title > a:active {
    display: block;
    padding: 1.3rem 2rem;
  }
  .panel-heading a:before {
    content: "\f0d7";
    font-family: "Font Awesome";
    float: right;
    transition: all 0.5s;
    color: #5b6770 !important;
  }
  .first-div {
    margin-right: 13px;
    width: 48px;
    height: 48px;
    overflow: hidden;
  }
  .first-div img {
    width: 100%;
    /* height: auto; */
    height: 100%;
  }
  .second-div {
    position: relative;
  }
  a.promotion-link span.time-ago {
    position: absolute;
    right: 20px;
    bottom: 59%;
    font-family: "Avenir Book";
    font-size: 14px;
    color: #646464;
  }
  .promotion-link p {
    margin: 0px !important
  }
  .ib-acq-navtab{
    display: flex !important;
    flex-flow: row !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/Notifications/Index.vue